import React, { useState } from "react";
import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure, Spinner, Input} from "@nextui-org/react";
import { POST } from "../../../../utils/requests";
import { orders_uri } from "../../../../utils/url";
import { toast } from "react-toastify";

export default function ReqOkayModal({callback, user, data}) {
  console.log(data)
  const {isOpen, onOpen, onOpenChange} = useDisclosure();
  const [load, setLoad] = useState(false);

  const handlecal = () => {
    callback();
  }
  
  const Sub = async () => {
    setLoad(true);
    if(data.length === 0){
      setLoad(false);
      return toast.success("Бараа хоосон");;
    }
    try{
        const res = await POST({uri:orders_uri+'/delivery-req', data:{phone: user.user.phone_no, deposit: user.user.deposit, user_id: user.user_id, id: user.id, datas: data}});
        if(res.status === 200){
          setLoad(false);
          toast.success("Амжилттай");
          onOpenChange(false);
          handlecal();
        }
    }catch(err){
        console.log(err);
        setLoad(false);
    }
  }

  return (
    <>
      <Button onPress={onOpen}>Баталгаажуулах</Button>
      <Modal isOpen={isOpen} onOpenChange={onOpenChange} scrollBehavior='inside' size="md">
        <ModalContent>
          {(onClose) => (
            <>
              <ModalBody>
                <div className="font-Roboto mt-6">
                    <h1 className="m-2 uppercase font-bold text-center">Та баталгаажуулахдаа итгэлтэй байна уу ?</h1>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="danger" variant="light" onPress={onClose}>
                  Болих
                </Button>
                {
                  load?
                  <Button color="primary">
                    <Spinner color="white"/>
                  </Button>
                  :
                  <Button color="primary" onPress={Sub}>
                    Баталгаажуулах
                  </Button>
                }
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}